import { createSelector } from 'reselect';

import { LOGIN_STEPS } from 'modules/auth/constant';
import type { RootState } from 'reducers/index';

const getAuthState = (state: RootState) => state.auth;

const getUI = createSelector(getAuthState, ({ ui }) => ui);

const getData = createSelector(getAuthState, ({ data }) => data);

export const getForgotPasswordIsLoading = createSelector(getUI, ({ forgotPasswordLoading }) => forgotPasswordLoading);

export const getForgotPasswordSubmitIsLoading = createSelector(
  getUI,
  ({ forgotPasswordSubmitLoading }) => forgotPasswordSubmitLoading
);

export const getSignInLoading = createSelector(getUI, ({ signInLoading }) => signInLoading);

export const getCurrentAuthStep = createSelector(getUI, ({ authStep }) => authStep);

export const getResendLoading = createSelector(getUI, ({ resendLoading }) => resendLoading);

export const getVerifySignInLoading = createSelector(getUI, ({ verifySignInLoading }) => verifySignInLoading);

export const hasVerifySignInError = createSelector(getUI, ({ verifySignInError }) => Boolean(verifySignInError));

const getLoginData = createSelector(getData, ({ stepData }) => stepData[LOGIN_STEPS.LOGIN]);

const getMFAEmailData = createSelector(getData, ({ stepData }) => stepData[LOGIN_STEPS.MFA_EMAIL]);

export const getLoginUsername = createSelector(getLoginData, loginData => loginData?.username);

export const getMFAEmail = createSelector(getMFAEmailData, data => data?.email);

export const isAccountLocked = createSelector(getMFAEmailData, data => data?.accountLocked === 'true');

export const getUnlockedAt = createSelector(getMFAEmailData, data => data?.unlockedAt);

export const canResend = createSelector(getMFAEmailData, mfaData => (mfaData ? Number(mfaData.remainingCode) > 0 : undefined));

export const getRetryExpiration = createSelector(getMFAEmailData, data => data?.retryExpiration);

export const getRemainingAttempt = createSelector(getMFAEmailData, data => (data ? Number(data.remainingAttempt) : undefined));
